import React from 'react';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { FDTextButton } from '@facet-wealth/design';
import { DataValueMap } from 'Helpers/Testing';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';

const NavigateAction = ({ relationship }) => {
  const [loading, setLoading] = React.useState(false);
  const { loadPageContentLink } = usePageContentContext();
  const { loadModalCollectionByLink } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleButtonClick = async (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
    setLoading(true);
    try {
      const link = relationship.link('related');
      if (relationship.meta('relationshipType') === 'linkModal') {
        await loadModalCollectionByLink(link.url());
        return;
      }

      await loadPageContentLink(link);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Unable to navigate');
    } finally {
      setLoading(false);
    }
  };

  return (
    <FDTextButton
      onClick={(evt) => handleButtonClick(evt)}
      {...DataValueMap.init('facet-plan-page-item-table-navigate-action').build()}
      loading={loading}
      label={relationship.meta('prompt')}
    />
  );
};

NavigateAction.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default NavigateAction;
